import { render } from "./MailboxIndex.vue?vue&type=template&id=dedee158"
import script from "./MailboxIndex.vue?vue&type=script&lang=js"
export * from "./MailboxIndex.vue?vue&type=script&lang=js"
script.render = render

export default script